import app from 'flarum/forum/app';
import { extend } from 'flarum/extend';
import TextEditor from 'flarum/forum/components/TextEditor';

app.initializers.add('maisen20/chatgpt-textenhancer', () => {
  extend(TextEditor.prototype, 'oncreate', function() {
    const isAdmin = app.session.user && app.session.user.groups().some(group => group.id() === '1'); // Überprüfe, ob der Benutzer zur Administratorgruppe gehört

    // Nur fortsetzen, wenn der Benutzer Admin ist
    if (!isAdmin) {
      console.log('Zugriff verweigert: Benutzer ist kein Administrator.');
      return;
    }

    const composerContainer = document.getElementById("composer");
    if (!composerContainer) {
      console.error('Composer container nicht gefunden.');
      return;
    }
    // Toolbar finden, wo der Button eingefügt werden soll
    const composerControls = composerContainer.querySelector('.Composer-controls');
    if (!composerControls) {
      console.error('Composer-Controls nicht gefunden.');
      return;
    }

    // Button erstellen
    const button = document.createElement('button');
    button.className = 'Button Button--icon Button--link hasIcon';
    button.setAttribute('type', 'button');
    button.setAttribute('aria-label', 'ChatGPT Text Enhancer');
    button.innerHTML = '<i aria-hidden="true" class="icon fas fa-magic Button-icon"></i>';

    // Klick-Event für den Button
    button.addEventListener('click', () => {
          const textArea = this.element.querySelector('textarea.FormControl');
          if(textArea == null) {
            alert("Kein Textfeld gefunden. Bitte sicherstellen, dass nicht mit formatiertem Text bearbeitet wird.");
            return;
          }
          const text = textArea.value;

          // Zugriff auf den bestehenden Ladeindikator
          const loadingIndicator = this.element.closest('.ComposerBody').querySelector('.ComposerBody-loading');
          loadingIndicator.style.display = 'flex';  // Ladeindikator anzeigen
          

          fetch('/api/enhance-text', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': app.session.csrfToken // Füge das CSRF-Token hier ein
            },
            body: JSON.stringify({text: text})
          })
          .then(response => response.json())
          .then(data => {
            loadingIndicator.style.display = 'none';
            if (textArea) {
              textArea.value = data.text.content;
              textArea.dispatchEvent(new Event('input')); // Löst das Input-Event manuell aus
            }
          })
          .catch(error => {
            loadingIndicator.style.display = 'none';
            console.error('Fehler bei der Textverbesserung:', error);
          });
    });

    const currentBtn = composerContainer.querySelector('.item-ChatGPTTextEnhancer');
    if(currentBtn != null) currentBtn.remove();

    // Button zur Toolbar hinzufügen
    const li = document.createElement('li');
    li.className = 'item-ChatGPTTextEnhancer';
    li.appendChild(button);

    // Prüfen, ob es bereits ein erstes Kind-Element gibt
    if (composerControls.firstChild) {
        // Füge das neue Element vor dem ersten Kind-Element ein
        composerControls.insertBefore(li, composerControls.firstChild);
    } else {
        // Wenn keine Kinder vorhanden sind, einfach am Ende hinzufügen
        composerControls.appendChild(li);
    }
  });
});
